import { useRef, useState, useEffect } from 'react';
import { Badge } from './ui/badge';
import { useIsLocationAllowed } from '@/hooks/useIsLocationAllowed';

export function HeaderTitle({ 
    nameColor = 'text-white',
    size = 'text-3xl',
    showState = true, 
}: { 
    nameColor?: string,
    size?: string 
    showState?: boolean
}) {
    const [isLocationAllowed] = useIsLocationAllowed();
    const textRef = useRef<HTMLSpanElement>(null);
    const badgeRef = useRef<HTMLDivElement>(null);
    const [showUnderline, setShowUnderline] = useState(false);
    
    useEffect(() => {
        let timeout: NodeJS.Timeout;
        if (showUnderline) {
            timeout = setTimeout(() => {
                setShowUnderline(false);
            }, 600);
        }
        return () => clearTimeout(timeout);
    }, [showUnderline]);

    const handleClick = () => {
        if (textRef.current) {
            textRef.current.classList.remove('animate-wiggle');
            void textRef.current.offsetWidth; // re-trigger animation
            textRef.current.classList.add('animate-wiggle');
        }
        if (badgeRef.current) {
            badgeRef.current.classList.remove('animate-pop');
            void badgeRef.current.offsetWidth;
            badgeRef.current.classList.add('animate-pop');
        }
        
        setShowUnderline(true);
    };

    return (
        // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
        <div 
            className="flex flex-col cursor-pointer" 
            onClick={handleClick}
            onMouseEnter={() => setShowUnderline(true)}
            onMouseLeave={() => setShowUnderline(false)}
        >
            <div className="flex items-center space-x-2">
                <span
                    ref={textRef}
                    className={`${size} ${nameColor} font-bold transition-all duration-300`}
                >
                    Scratch
                </span>
                {showState && (
                    isLocationAllowed?.locationName && (
                        <div ref={badgeRef}>
                            <Badge className="text-base bg-blue-light text-white">
                                {isLocationAllowed.locationName}
                            </Badge>
                        </div>
                    )
                )}
            </div>
            
            <div 
                className={`h-0.5 bg-white transition-all duration-300 ${
                    showUnderline ? 'w-full animate-pulse-medium' : 'w-0'
                }`} 
            />
        </div>
    );
}